import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Note from './Note';

const NoteSortable = (({ item, isSortable, newId, renameNote, goToNote, isOwner, notesEdit }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    visibility: isDragging ? 'hidden' : 'visible',
  };

  return (
    <Note
      {...item}
      style={style}
      isSortable={isSortable}
      isNew={item.id === newId}
      renameNote={renameNote}
      goToNote={goToNote}
      key={`modal-reorder__${item.id}`}
      setNodeRef={setNodeRef}
      attributes={attributes}
      listeners={listeners}
      isOwner={isOwner}
      notesEdit={notesEdit}
    />
  );
});

export default NoteSortable;
